function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.078 4.368A5.462 5.462 0 0 0 8.708.014c-1.088 0-2.104.29-2.902.871l1.088 1.089c.508-.363 1.161-.508 1.814-.508 2.177 0 3.992 1.814 3.992 3.99v.364h1.088c1.234 0 2.177.943 2.177 2.177 0 .798-.435 1.524-1.16 1.887l1.088 1.088c.943-.653 1.524-1.741 1.524-2.975 0-1.887-1.524-3.483-3.339-3.629zM2.178.958l2.031 1.959C1.887 3.062 0 4.949 0 7.271a4.367 4.367 0 0 0 4.354 4.354h8.49l1.452 1.452.944-.944L3.12.014l-.943.944zm3.41 3.41 5.805 5.806H4.354A2.911 2.911 0 0 1 1.451 7.27a2.911 2.911 0 0 1 2.903-2.903h1.234z",
  fill: "#D34242",
  fillRule: "nonzero"
});

function SvgDisconnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.e0324211.svg";
export { ForwardRef as ReactComponent };